import { Component, signal } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-monthly-uploads',
  templateUrl: './monthly-uploads.component.html',
  styleUrl: './monthly-uploads.component.scss',
})
export class MonthlyUploadsComponent {
  isLoading = signal(0);

  selectedSection = new FormControl<number>(1);

  sections: { label: string; value: number }[] = [
    { label: 'Employee Costs', value: 1 },
    { label: 'Asset Depreciation', value: 2 },
    { label: 'Service Costs', value: 3 },
  ];

  private startLoading(): void {
    this.isLoading.update((v) => v + 1);
  }

  private stopLoading(): void {
    this.isLoading.update((v) => v - 1);
  }
}
